import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Collapsible } from '../../../../components/Collapsible';
import { AdvancedOptionsButton } from '../../../../components/automation/AutomationStepCard/presentation';
import { styleSheet } from '../../../../components/automation/AutomationStepCard/styles';
import { DisplayField } from '../../components/DisplayField';
import { rendererContainer, infoBoxYellow } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface HtmlNewsletterStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

export function HtmlNewsletterStepRenderer({
	nodeId: _nodeId,
	data,
	readOnly: readOnlyProp,
}: HtmlNewsletterStepRendererProps) {
	const { automationStep, automationTemplate, stepData } = data;
	const newsletterStep = automationStep as Api.IHtmlNewsletterAutomationStep;
	const template = automationTemplate;

	const isDemoMode = !newsletterStep && !template;

	const name = newsletterStep?.name || stepData?.name || '';
	const hasContent = newsletterStep?.content || stepData?.hasContent || false;
	const tagToAddOnClick = newsletterStep?.tagToAddOnClick || '';
	const sendFromOption = newsletterStep?.sendFromOptions;
	const contactFilter = newsletterStep?.contactFilter;

	const hasTagOption = !!tagToAddOnClick;
	const hasSendFromOption = !!sendFromOption && sendFromOption.mode !== Api.SendEmailFrom.CurrentUser;
	const hasContactFilter = !!contactFilter?.criteria && contactFilter.criteria.length > 0;
	const hasAdvancedOptions = hasTagOption || hasSendFromOption || hasContactFilter;
	const [advancedOptionsToggled, setAdvancedOptionsToggled] = React.useState(hasAdvancedOptions);

	return (
		<div className={css(rendererContainer)}>
			{isDemoMode && <div className={css(infoBoxYellow)}>⚠ Demo Mode: Changes are not persisted</div>}
			<DisplayField
				label='HTML Newsletter:'
				value={name}
				required
				readOnly={readOnlyProp}
				placeholder='No name set'
				withMargin
			/>
			<DisplayField
				label='Template:'
				value={hasContent ? 'Template selected' : null}
				readOnly={readOnlyProp}
				placeholder='No template selected'
				withMargin
			/>
			{hasAdvancedOptions && (
				<>
					<AdvancedOptionsButton
						isCollapsed={!advancedOptionsToggled}
						onClick={() => setAdvancedOptionsToggled(!advancedOptionsToggled)}
					/>
					<Collapsible isCollapsed={!advancedOptionsToggled}>
						<div className={css(styleSheet.advancedOptionsContent)}>
							{hasTagOption && (
								<div style={{ marginBottom: 12 }}>
									<div style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 4 }}>
										Add tag on link click:
									</div>
									<div style={{ fontSize: 13, color: '#374151' }}>{tagToAddOnClick}</div>
								</div>
							)}
							{hasSendFromOption && (
								<div style={{ marginBottom: 12 }}>
									<div style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 4 }}>Send from:</div>
									<div style={{ fontSize: 13, color: '#374151' }}>
										{sendFromOption?.mode === Api.SendEmailFrom.Connection
											? `Connection: ${sendFromOption.connectionId || 'N/A'}`
											: 'Custom sender'}
									</div>
								</div>
							)}
							{hasContactFilter && (
								<div>
									<div style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 4 }}>
										Contact filter:
									</div>
									<div style={{ fontSize: 12, color: '#374151' }}>
										{contactFilter?.criteria?.length} filter{contactFilter?.criteria?.length !== 1 ? 's' : ''} applied
									</div>
								</div>
							)}
						</div>
					</Collapsible>
				</>
			)}
		</div>
	);
}
